import { atom } from 'recoil';

export const modalState = atom({
  key: 'modalState',
  default: {
    type: '',
    props: {} as any
  }
});
